export const feedbackEn = {
  open: 'Give feedback',
  title: 'Give feedback',
  description: 'Report a problem, question or suggestion without leaving the current page.',
  submit: 'Send feedback',
  submitting: 'Sending …',
  types: {
    BUG: 'Something is not working',
    FEATURE_REQUEST: 'Feature request',
    IMPROVEMENT: 'Improvement suggestion',
    USABILITY: 'Usability issue',
    DATA_ISSUE: 'Data looks wrong or incomplete',
    PERFORMANCE: 'Page is slow or unresponsive',
    QUESTION: 'Question about a feature',
    OTHER: 'Other',
  },
  urgencies: { LOW: 'Low', NORMAL: 'Normal', HIGH: 'High', BLOCKING: 'I cannot continue working' },
  reproducibility: {
    ALWAYS: 'Always',
    SOMETIMES: 'Sometimes',
    ONCE: 'Once',
    NOT_TRIED: 'Not tried yet',
  },
  statuses: {
    SUBMITTED: 'Submitted',
    TRIAGED: 'Triaged',
    IN_PROGRESS: 'In progress',
    RESOLVED: 'Resolved',
    CLOSED: 'Closed',
  },
  priorities: { LOW: 'Low', MEDIUM: 'Medium', HIGH: 'High', CRITICAL: 'Critical' },
  fields: {
    type: 'Report type',
    urgency: 'Perceived urgency',
    title: 'Short title',
    description: 'Detailed description',
    noSecrets: 'Do not enter passwords, tokens, payment data or confidential content.',
    attemptedAction: 'What did you try?',
    actualResult: 'What actually happened?',
    expectedResult: 'What did you expect instead?',
    reproducibility: 'Can the issue be reproduced?',
    reproductionSteps: 'Optional reproduction steps',
    affectedFeature: 'Affected feature (optional)',
    wantsFollowUp: 'I would like a follow-up',
    problematicFields: 'Problematic fields',
    choose: 'Please choose',
  },
  bug: { title: 'Bug details' },
  screenshot: {
    title: 'Screenshot (optional)',
    hint: 'Review and mask confidential areas before sending.',
    choose: 'Choose image',
    remove: 'Remove',
    invalid: 'The image could not be read.',
    maskArea: 'Screenshot masking area',
    maskInstructions: 'Drag over confidential areas to permanently black them out.',
    resetMasks: 'Reset masks',
  },
  diagnostics: {
    includeExtended: 'Include extended diagnostics',
    title: 'Show diagnostic data',
    transparency:
      'You decide which technical sections are sent. Verified session context is added by the server.',
    exclusions:
      'Inputs, search terms, passwords, tokens, messages, files, clipboard, audio, camera, location and mouse movement are never captured.',
    sections: {
      APPLICATION: 'Application & build',
      PAGE: 'Current page',
      BROWSER: 'Browser & device',
      BREADCRUMBS: 'Recent semantic actions',
    },
  },
  discard: {
    title: 'Discard draft?',
    description: 'Your unsent information will be lost.',
    continue: 'Continue editing',
    confirm: 'Discard draft',
  },
  success: {
    title: 'Feedback sent',
    description: 'Keep this reference for follow-up questions.',
    toast: 'Feedback {{reference}} was sent.',
  },
  admin: {
    requested: 'Yes',
    nav: 'Feedback centre',
    title: 'Feedback centre',
    subtitle: 'Manage deliberately submitted feedback with sanitised diagnostic context.',
    loadError: 'Feedback could not be loaded.',
    empty: 'No feedback matches the selected filters.',
    detailTitle: 'Feedback details',
    screenshotAlt: 'Masked screenshot for {{reference}}',
    triage: 'Technical triage',
    unrated: 'Not rated',
    saved: 'Feedback updated.',
    invalidErrorIds: 'The error references are invalid.',
    linkedErrors: 'Linked system errors',
    kpi: { open: 'Open reports', untriaged: 'Not triaged', last24h: 'Last 24 hours' },
    columns: {
      reference: 'Reference',
      createdAt: 'Time',
      type: 'Type',
      title: 'Title',
      user: 'User',
      status: 'Status',
    },
    fields: {
      status: 'Workflow status',
      priority: 'Technical priority',
      errorIds: 'Error tracking IDs (comma-separated)',
      notes: 'Internal notes',
    },
    filters: {
      search: 'Reference, title or description',
      type: 'Filter type',
      status: 'Filter status',
      priority: 'Filter priority',
      all: 'All',
    },
    prompt: {
      title: 'Sanitised support/Copilot prompt',
      hint: 'Free text and diagnostics are checked again for secrets and personal patterns before copying.',
      copy: 'Copy sanitised prompt',
      copied: 'Sanitised prompt copied.',
    },
  },
} as const;
